import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	subscription: {
		data: {},
		isBeingSubmitted: false,
		paymentSuccessful: false,
		isLoading: false,
		hasBeenLoaded: false,
		error: ''
	}
};

export const paymentsSlice = createSlice({
	name: 'payments',
	initialState,
	reducers: {
		createSubscription: (state) => {
			state.subscription.isBeingSubmitted = true;
		},
		createSubscriptionCompleted: (state, action) => {
			state.subscription.data = action.payload;
			state.subscription.paymentSuccessful = true;
			state.subscription.error = undefined;
			state.subscription.isLoading = false;
			state.subscription.hasBeenLoaded = true;
		},
		createSubscriptionFailed: (state, action) => {
			state.subscription.isLoading = false;
			state.subscription.error = action.payload;
			state.subscription.hasBeenLoaded = false;
		}
	}
});

export const {
	createSubscription,
	createSubscriptionCompleted,
	createSubscriptionFailed
} = paymentsSlice.actions;

export default paymentsSlice.reducer;
